import React from "react";
import { Localize } from "components/service";
import { getStaffAuditAccuracyQuality } from "../helpers/staff-audit-log-presentation-helper";


const StaffAuditAccuracyField = ({ accuracy }) => {
    const quality = getStaffAuditAccuracyQuality(accuracy);

    if (quality === "unknown")
    {
        return <span className="staff-audit-accuracy staff-audit-accuracy--unknown">—</span>;
    }

    return (
        <span
            className={ `staff-audit-accuracy staff-audit-accuracy--${ quality }` }
            title={ `${ accuracy } m` }>
            {/* <span className="staff-audit-accuracy__dot" aria-hidden="true" /> */}
            <span className="staff-audit-accuracy__label">
                <Localize>{ `STAFF_MANAGEMENT.AuditAccuracy_${ quality }` }</Localize>
            </span>{ " " }
            <span className="staff-audit-accuracy__value">
                ({ Number(accuracy.toFixed(2)) } m)
            </span>
        </span>
    );
};

export default StaffAuditAccuracyField;
